export const wordsList = {
  carro: ["motor", "porta", "capo", "pneu", "antena"],
  fruta: ["morango", "manga", "laranja", "pessego", "maracuja"],
  corpo: ["cabeca", "braco", "perna", "pescoco", "olho"],
  computador: ["monitor", "teclado", "mouse", "gabinete", "processador"],
  programação: ["linguagem", "framework", "javascript", "react", "site"],
  alimento: ["arroz", "feijao", "macarrao", "carne", "leite"],
  sala: ["sofa", "televisao", "quadro", "cadeira", "antena"],
  cozinha: ["fogao", "geladeira", "bebedouro", "mesa", "prato"],
  casa: ["porta", "parede", "telhado", "piso", "janela"],
  animal: ["girafa", "peixe", "gorila", "cavalo", "elefante"],
  cor: ["azul", "amarelo", "vermelho", "verde", "branco"],
};
